module.exports = __webpack_public_path__ + "img/photo.986ce366.svg";